export const CONSENT_COOKIE_NAME = "cookieConsent";
const CONSENT_MAX_AGE_DAYS = 180;
const RESET_EVENT = "cookie-consent:reset";

export const getConsentCookie = () => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`));
  return match ? match.split("=")[1] : null;
};

export const setConsentCookie = () => {
  const expires = new Date(
    Date.now() + CONSENT_MAX_AGE_DAYS * 24 * 60 * 60 * 1000,
  ).toUTCString();
  document.cookie = `${CONSENT_COOKIE_NAME}=true; expires=${expires}; path=/; SameSite=Lax`;
};

export const clearConsentCookie = () => {
  document.cookie = `${CONSENT_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

export const openCookieSettings = () => {
  window.dispatchEvent(new Event(RESET_EVENT));
};

export const onCookieSettingsRequested = (handler) => {
  window.addEventListener(RESET_EVENT, handler);
  return () => window.removeEventListener(RESET_EVENT, handler);
};
